<template lang="pug">
  el-alert.top-warning(v-if='relativeFutureStartDate' :title="`This ${name} goes live in ${relativeFutureStartDate}`"
    type="info" show-icon :closable='false')
</template>

<script>
import isFuture from "date-fns/is_future";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";

export default {
  props: {
    name: {
      required: true,
      type: String
    },
    startDatetime: {}
  },
  computed: {
    relativeFutureStartDate() {
      if (!this.startDatetime || !isFuture(this.startDatetime)) {
        return null;
      }
      return distanceInWordsStrict(this.startDatetime, new Date());
    }
  }
};
</script>

<style scoped lang="scss">
.top-warning {
  margin-bottom: 20px;
  :global(.el-alert__title) {
    font-size: 18px;
  }
}
</style>
